module.exports = __webpack_public_path__ + "img/pet_bostie.5d0e74f3.svg";